import { useEffect, useState } from "react";
import type { WorkspaceModel } from "./useWorkspace";
import { sheetAt } from "./sheet-operations";
export function FileDropTarget({ model }: { model: WorkspaceModel }) {
  const [target, setTarget] = useState<string | null>(null);
  useEffect(() => {
    const { editor } = model;
    const inside = (e: DragEvent) => {
      const b = editor.getViewportScreenBounds();
      return (
        e.clientX >= b.x &&
        e.clientY >= b.y &&
        e.clientX <= b.maxX &&
        e.clientY <= b.maxY
      );
    };
    const over = (e: DragEvent) => {
      if (!e.dataTransfer?.types.includes("Files") || !inside(e)) return;
      e.preventDefault();
      e.dataTransfer.dropEffect =
        model.canEdit && !model.modal ? "copy" : "none";
      const point = editor.screenToPage({ x: e.clientX, y: e.clientY });
      const sheet = sheetAt(editor, point);
      setTarget(
        model.modal
          ? "Close the dialog to add files"
          : sheet
            ? `Add files to ${sheet.props.name}`
            : "Add files to the board",
      );
      editor.setHintingShapes(sheet ? [sheet.id] : []);
    };
    const clear = () => {
      setTarget(null);
      editor.setHintingShapes([]);
    };
    const leave = (e: DragEvent) => {
      if (!e.relatedTarget) clear();
    };
    const drop = (e: DragEvent) => {
      if (!e.dataTransfer?.files.length || !inside(e)) return;
      e.preventDefault();
      e.stopPropagation();
      clear();
      if (!model.canEdit || model.modal) return;
      model.imports.add(
        Array.from(e.dataTransfer.files),
        editor.screenToPage({ x: e.clientX, y: e.clientY }),
      );
    };
    window.addEventListener("dragover", over, true);
    window.addEventListener("drop", drop, true);
    window.addEventListener("dragleave", leave);
    window.addEventListener("dragend", clear);
    return () => {
      window.removeEventListener("dragover", over, true);
      window.removeEventListener("drop", drop, true);
      window.removeEventListener("dragleave", leave);
      window.removeEventListener("dragend", clear);
    };
  }, [model.editor, model.canEdit, model.modal, model.imports.add]);
  return target ? (
    <div className="file-drop-target" role="status">
      <strong>{target}</strong>
      <span>Release to add · PDFs, images, documents and other files</span>
    </div>
  ) : null;
}
